import type {
  CallDefectsSuggestionsInferenceEndpointParams,
  GetDefectsSuggestionsParams,
} from "./getDefectsSuggestions.type";
import type { LiteralObject } from "@/types";

import { t } from "i18next";

import { getInstanceName } from "@/config/environmentUtils";

import {
  callInferenceEndpoint,
  getMaterialEndpoint,
} from "./getDefectsSuggestions.utils";

const MAX_SUGGESTIONS_ITEM = 3;

const callDefectsSuggestionsInferenceEndpoint = ({
  datasetsRepetitionIndex,
  datasetsInterventionId = 0,
  images = [],
  endpoint = "",
}: CallDefectsSuggestionsInferenceEndpointParams) => {
  const body = {
    client: getInstanceName(),
    datasets_repetition_index: datasetsRepetitionIndex,
    datasets_intervention_id: datasetsInterventionId,
    images: images,
  };

  return callInferenceEndpoint({ body, endpoint });
};

export const getDefectsSuggestions = async ({
  selectedMaterial = "",
  datasetsImage = [],
}: GetDefectsSuggestionsParams) => {
  const endpoint = getMaterialEndpoint(selectedMaterial);

  // TODO: DEV-5408
  // If material is not supported, early return
  // if (!endpoint) {
  //   return {
  //     defects: [],
  //     error: t(
  //       "form:staticField.defectSuggestion.error.materialNotSupported"
  //     ),
  //   };
  // }

  if (datasetsImage.length === 0) {
    return {
      defects: [],
      error: t("form:staticField.defectSuggestion.error.noImage"),
    };
  }

  const images: LiteralObject[] = [];
  datasetsImage.forEach((dataset) => {
    images.push({ datasets_id: dataset.id, url: dataset.data_path });
  });

  // TODO IMP-1310 use something else than `repetition_index` when suggestion endpoint will be ready
  const inferenceResults = await callDefectsSuggestionsInferenceEndpoint({
    datasetsRepetitionIndex: datasetsImage[0]?.repetition_index,
    datasetsInterventionId: datasetsImage[0]?.intervention_id,
    images,
    endpoint,
  });

  const threshold = 1 / Object.keys(inferenceResults).length;

  const defects = Object.keys(inferenceResults)
    .map((key) => ({
      defect: key,
      confidence: inferenceResults[key],
      suggested: false,
    }))
    .sort((a, b) => b.confidence - a.confidence);

  let suggestedCount = 0;
  for (const defect of defects) {
    if (
      suggestedCount < MAX_SUGGESTIONS_ITEM &&
      defect.confidence >= threshold
    ) {
      defect.suggested = true;
      suggestedCount++;
    } else {
      defect.suggested = false;
    }
  }

  if (defects.length === 0) {
    return {
      defects: [],
      error: t("form:staticField.defectSuggestion.error.noSuggestionFound"),
    };
  }

  return {
    defects,
    error: "",
  };
};
